import React from 'react';
import { Guess } from '../Guess/Guess';

interface GuessScoreColumnProps {
  guesses: string[][];
  scores: string[][];
}

export class GuessScoreColumn extends React.Component<GuessScoreColumnProps> {
  generateGuessRows(){
    const nodes: React.ReactNode[] = [];
    const { guesses, scores } = this.props;
    guesses.forEach( (guess, index) => {
      nodes.push(
        <Guess  key={index}
                guess={guess}
                score={scores[index]}
        />
      )
    })
    return nodes;
  }

  generateEmptyRows(){
    const nodes: React.ReactNode[] = [];
    const { guesses } = this.props;
    for(let i = 0; i < 8 - guesses.length; i++){
      nodes.push(
        <Guess
          key = {i + guesses.length}
          guess={[]}
          score={[]}
        />
      );
    }
    return nodes;
  }

  render(): React.ReactNode {
    return (
      <div className="flex flex-col items-center w-full h-full gap-1">
        {this.generateGuessRows()}
        {this.generateEmptyRows()}
      </div>
    );
  }
}
